'use strict';

const DAY_MS = 24 * 60 * 60 * 1000;

function normalize(value) {
  return String(value || '').trim().toLowerCase();
}

function normalizeConsultationType(step = {}) {
  const type = normalize(step?.consulenzaType);
  if (type === 'tecnica') return 'tecnica';
  if (type === 'nutrizionale') return 'nutrizionale';
  return null;
}

function isConsultation(step = {}) {
  return normalize(step?.name).includes('consulenza');
}

function isConsultationPending(step = {}) {
  if (!isConsultation(step) || !normalizeConsultationType(step) || step.done || step.doneAt) return false;
  return ['', 'da fare', 'contattata', 'contattato'].includes(normalize(step.consulenzaStatus));
}

function isDeliveryDone(step = {}) {
  if (!normalize(step?.name).includes('consegna') || step.done !== true || !step.doneAt) return false;
  const date = typeof step.doneAt?.toDate === 'function' ? step.doneAt.toDate() : new Date(step.doneAt);
  return Number.isFinite(date.getTime());
}

function getPostDeliveryConsultations(steps = [], deliveryIndex) {
  if (!Array.isArray(steps) || !normalize(steps[deliveryIndex]?.name).includes('consegna')) return [];
  const nextDelivery = steps.findIndex((step, index) => index > deliveryIndex && normalize(step?.name).includes('consegna'));
  return steps.flatMap((step, index) => {
    if (!isConsultation(step) || !normalizeConsultationType(step)) return [];
    const placement = normalize(step.consulenzaPlacement);
    if (placement === 'before-consegna' || placement === 'standalone') return [];
    // Keep converted consultations tied to their original delivery, regardless of their displayed order.
    const afterDelivery = index > deliveryIndex && (nextDelivery < 0 || index < nextDelivery);
    if (!afterDelivery) return [];
    return [{ step, index }];
  });
}

function buildConsultationReminderTitle(step = {}) {
  const type = normalizeConsultationType(step);
  return type ? `Promemoria consulenza ${type}` : 'Promemoria consulenza';
}

function buildConsultationReminderMessage(step = {}) {
  const type = normalizeConsultationType(step);
  if (!type) return '';
  const technical = type === 'tecnica';
  return [
    'Ciao! 😊',
    technical
      ? 'Il tuo programma include una consulenza tecnica con un Personal Trainer.'
      : 'Il tuo programma include una consulenza nutrizionale.',
    `Ricordati di fissare la videocall ${type}: contatta l’Assistenza ${technical ? 'Tecnica' : 'Nutrizionale'} indicando i giorni e le fasce orarie in cui sei disponibile.`,
    technical
      ? 'Durante la call potrai chiarire i dubbi sulla scheda e vedere alcuni esercizi: prepara abbigliamento sportivo e uno spazio adatto.'
      : 'Durante la call potrai confrontarti sul piano alimentare e chiarire i tuoi dubbi con il nostro staff nutrizionale.',
    'La call va svolta entro la durata del programma.',
  ].join('\n\n');
}

function buildPendingConsultationBookingMessage(steps = []) {
  const types = [...new Set((Array.isArray(steps) ? steps : [])
    .filter(isConsultationPending).map(normalizeConsultationType))];
  return types.map(type =>
    `Ricordati di fissare la videocall ${type} tramite l’Assistenza ${type === 'tecnica' ? 'Tecnica' : 'Nutrizionale'}.`
  ).join('\n');
}

function buildConsultationReminderId(percorsoId, deliveryIndex, consultationIndex) {
  return `${percorsoId}__${deliveryIndex}__${consultationIndex}`;
}

module.exports = {
  DAY_MS,
  normalizeConsultationType,
  isConsultationPending,
  isDeliveryDone,
  getPostDeliveryConsultations,
  buildConsultationReminderTitle,
  buildConsultationReminderMessage,
  buildPendingConsultationBookingMessage,
  buildConsultationReminderId,
};
